import React from "react";
import { connect } from "react-redux";
import order from "../../../../models/order";
import { pdt } from "hf-rt";
import { Translation } from "react-i18next";

class Quantity extends React.Component {
  isPurchaseMoreThanStock(fn) {
    const { max, quantity } = this.props;
    if (quantity >= max) {
      return null;
    }
    return fn;
  }
  isPurchaseMin(fn) {
    const { quantity } = this.props;
    if (quantity <= 1) return null;
    return fn;
  }

  render() {
    const { max, quantity, substract, increment } = this.props;
    return (
      <div className="detailsSection quantity_wrap">
        <p className="subtitle">
          <Translation>{t => <>{t("quantity.quantity")}</>}</Translation>
        </p>

        <div className="quantityInput_wrap">
          <span className="spinner">
            <span className="sub" onClick={this.isPurchaseMin(substract)}>
              <span className="stroke"></span>
            </span>
            <input
              type="number"
              name="quantity"
              id="quantity"
              min="1"
              value={quantity}
              readOnly
            />
            <span
              className="add"
              onClick={pdt.isOutOfStock(
                { stock: max, purchase: 0 },
                this.isPurchaseMoreThanStock(increment)
              )}
            >
              <span className="stroke"></span>
              <span className="stroke"></span>
            </span>
          </span>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    quantity: state.order.quantity
  };
};
const mapDispatchToProps = () => {
  return {
    substract: () => order.actions.substract(),
    increment: () => order.actions.increment()
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Quantity);
